const AD_TYPES = {
    push:1,
    native: 2,
    banner: 3,
    video: 4,
    tgb: 6,
    popup: 7
}

export default AD_TYPES